import { useQuery } from "@tanstack/react-query";

import type { DownloadFileResponse } from "~/api/fileManager";
import { downloadFile, getFileManager } from "~/api/fileManager";
import type { SortDirection } from "~/api/types";
import { usePaginatedQuery } from "./usePaginatedQuery";

export const useGetFileManager = (
  currentPage: number,
  orderBy: string | null,
  search: string,
  sortDirection: SortDirection | null,
  pageSize: number,
) => {
  const {
    query: { data: fileManagerData, isLoading: isLoadingFileManager },
    totalItems: totalFileManager,
  } = usePaginatedQuery({
    queryFn: () =>
      getFileManager({
        page: currentPage,
        per_page: pageSize,
        search,
        order_by: orderBy ?? "created_at",
        sort_direction: sortDirection ?? "DESC",
      }),
    queryKey: [
      "getFileManager",
      {
        page: currentPage,
        pageSize,
        search,
        orderBy,
        sortDirection,
      },
    ],
  });

  return {
    fileManagerData,
    isLoadingFileManager,
    totalFileManager,
  };
};

export const useDownloadFile = (fileId: number) => {
  const { data, isLoading: isDownloadingFile } = useQuery<DownloadFileResponse>(
    {
      queryKey: ["downloadFile", fileId],
      queryFn: async () => {
        const response = await downloadFile(fileId);
        return response.data;
      },
      enabled: !!fileId,
    },
  );

  return {
    data,
    isDownloadingFile,
  };
};
